import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  annotation as annotationConstants,
  build as buildConstants
} from './../helpers';
import { annotations as annotationActions } from './../actions';
import {
  getBuildInfo,
  getBuildsByTypeAndBuildNumber
} from './../reducers';
import { annotation as annotationSelectors } from './../selectors';
import FeedbackContainer from './FeedbackContainer';
import AddCommentModalContainer from './AddCommentModalContainer';
import ShowCommentsModalContainer from './ShowCommentsModalContainer';
export class BuildFeedbackContainer extends React.Component {
  static propTypes = {
    build: PropTypes.shape({ id: PropTypes.number.isRequired }),
    annotations: PropTypes.object.isRequired
  };

  removeBuildCommentByBuildId = (annotatedItem) => {
    return (dispatch, getState) => {
      const userName = localStorage.getItem('userName') || '';
      const state = getState();
      const annotationsById = annotationSelectors.
        getAnnotationsByBuildIdsOrderByDate(state);
      const relevantAnnotations = annotationsById[annotatedItem.id] || [];
      const usersCurrentAnnotation = relevantAnnotations.find(a => a.user === userName);
      if (usersCurrentAnnotation) {
        dispatch(annotationActions.removeBuildComment(usersCurrentAnnotation.id));
      }
    };
  }

  render() {
    return (
      <div>
        <AddCommentModalContainer
          addCommentAction={annotationActions.addBuildComment}
          preSubmitAction={this.removeBuildCommentByBuildId}
          statusList={annotationConstants.getBuildFeedbackStatusList()}
          ticketStatusFunc={() => null}
        />
        <ShowCommentsModalContainer
          annotations={this.props.annotations}
          glyphFunc={() => null}
          removeCommentAction={annotationActions.removeBuildComment}
        />
        <FeedbackContainer
          annotatedItem={this.props.build}
          annotationType={annotationConstants.BUILD_TYPED}
          title={'Build Feedback'}
          disabledText={'Log into JIRA and select a build to enable voting'}
        />
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  const info = getBuildInfo(state);
  const builds = getBuildsByTypeAndBuildNumber(state)(info);
  let build = null;
  if (builds && builds.length !== 1) {
    build = builds.find(b =>
      b.product === buildConstants.getProdNameByProductName(info.product));
  } else if (builds) {
    build = builds[0];
  }
  const annotations = annotationSelectors.getAnnotationsByBuildIdsOrderByDate(state);
  return { build, annotations };
};

export default connect(
  mapStateToProps
)(BuildFeedbackContainer);


// WEBPACK FOOTER //
// src/Containers/BuildFeedbackContainer.jsx